import template from './toggleControl.html';
import controller from './toggleControl.controller';

export default {
  restrict: 'E',
  bindings: {
    model: '=',
    controlId: '@',
    label: '@',
    labelValues: '<',
    infoTextKey: '@',
    isDisabled: '=',
  },
  transclude: true,
  template,
  controller,
  controllerAs: 'vm',
};



// WEBPACK FOOTER //
// ./src/app/common/ui/toggleControl/toggleControl.component.js